import { put, fork, call, takeEvery, select, all } from 'redux-saga/effects';
import app from '../../app';
import { strLength } from '../../utils/string';

import {
  loadLetterHomeCompletion,
  editLetterAgentCompletion,
  catchError,
} from '../../actions';

export function* watchLoadLetter() {
  yield takeEvery('LOAD_LETTER_HOME', function*() {
    const options = {
      url: '/sfapi/reply/detail',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadLetterHomeCompletion(result.error, result.data));
  });
}

export function* watchEditLetter() {
  yield takeEvery('EDIT_LETTER_AGENT', function*() {
    const edit = yield select(state => state.activity.letter.edit);
    const {
      input: { content },
    } = edit;

    let error;
    const submitContent = content.trim();
    if (!submitContent) {
      error = new Error('还没填写回复内容哦');
    }
    if (strLength(submitContent) > 800) {
      error = new Error('回复内容不能超过800字哦');
    }

    if (error) {
      yield put(catchError(error));
      yield put(editLetterAgentCompletion(error));
      return;
    }

    const options = {
      url: '/sfapi/reply/add',
      method: 'POST',
      data: { text: submitContent },
    };

    const result = yield call(app.httpFetch, options);
    yield put(editLetterAgentCompletion(result.error, result.data));
  });
}

export default function* letterSaga() {
  yield all([fork(watchLoadLetter), fork(watchEditLetter)]);
}
